import {Capacitor} from "@capacitor/core";

export const config = {
    version:           (<any>import.meta).env.VITE_VERSION,
    firebase_project:  (<any>import.meta).env.VITE_FIREBASE_PROJECT,
    apiUrl:            (<any>import.meta).env.VITE_API_BASE_URL,
    publicUrl:         (<any>import.meta).env.VITE_PUBLIC_BASE_URL,
    googleMapsApiKey:  (<any>import.meta).env.VITE_GOOGLE_MAPS_API_KEY || '',
    debugParams:       (<any>import.meta).env.VITE_DEBUG_PARAMS,
    pusherHost:        (<any>import.meta).env.VITE_PUSHER_HOST,
    pusherPort:        (<any>import.meta).env.VITE_PUSHER_PORT ? parseInt((<any>import.meta).env.VITE_PUSHER_PORT) : undefined,
    pusherAppKey:      (<any>import.meta).env.VITE_PUSHER_APP_KEY || 'ws-app',
    isCordova:         (<any>import.meta).env.VITE_IS_CORDOVA === 'true',
    pusherForceTls:    (<any>import.meta).env.MODE !== 'development',
    appEnv:            (<any>import.meta).env.MODE === 'development' ? 'local' : (<any>import.meta).env.MODE, // provide value matching Laravel APP_ENV
    jwtRefreshSeconds: ((<any>import.meta).env.VITE_JWT_REFRESH_MINUTES || 15) * 60,
    isProduction() {
        return config.appEnv === 'production';
    },

    clarityProjectId:    ((<any>import.meta).env.VITE_CLARITY_PROJECT_ID || ''),
    bugsnagApiKey:       ((<any>import.meta).env.VITE_BUGSNAG_API_KEY || ''),
    bugsnagReleaseStage: (<any>import.meta).env.MODE,

    featureEnableSignup:           ((<any>import.meta).env.VITE_FEATURE_ENABLE_SIGNUP === 'yes'),
    featureEnableLeagueSetup:      ((<any>import.meta).env.VITE_FEATURE_ENABLE_LEAGUE_SETUP === 'yes'),
    featureEnableCourts:           (Capacitor.getPlatform() !== 'ios' && (<any>import.meta).env.VITE_FEATURE_ENABLE_CLUB_COURTS === 'yes'),

    featureEnableStripePayments:   (Capacitor.getPlatform() !== 'ios'),
    featureEnableEarnAsYouPlay:    ((<any>import.meta).env.VITE_FEATURE_ENABLE_EARN_AS_YOU_PLAY === 'yes'),
    featureEnableReferralsPage:    ((<any>import.meta).env.VITE_FEATURE_ENABLE_REFERRALS_PAGE === 'yes'),
    featureEnableAiInsights:       ((<any>import.meta).env.VITE_FEATURE_ENABLE_AI_INSIGHTS_TAB === 'yes'),
    featureEnableBillingSection:   ((<any>import.meta).env.VITE_FEATURE_ENABLE_BILLING_SECTION === 'yes'),
    featureEnablePlayerAbility:    ((<any>import.meta).env.VITE_FEATURE_ENABLE_PLAYER_ABILITY === 'yes'),
    featureEnableClubVerification: ((<any>import.meta).env.VITE_FEATURE_ENABLE_CLUB_VERIFICATION === 'yes'),
    featureEnableAdditionalSports: ((<any>import.meta).env.VITE_FEATURE_ENABLE_ADDITIONAL_SPORTS === 'yes'),
    // Organizer gamification (badges, progress panels, League of Organisers board) and the
    // per-player match fee ledger ship dark to production until these are flipped to "yes".
    featureEnableOrganizerGamification: ((<any>import.meta).env.VITE_FEATURE_ENABLE_ORGANIZER_GAMIFICATION === 'yes'),
    featureEnableMatchFees:             ((<any>import.meta).env.VITE_FEATURE_ENABLE_MATCH_FEES === 'yes'),
    // "Continue with Discord" on login and "Link Discord" on the profile. Off on production for now.
    featureEnableDiscordLogin:          ((<any>import.meta).env.VITE_FEATURE_ENABLE_DISCORD_LOGIN === 'yes'),
    // Running/races ships to production dark: the code is live but the sport must not be offered to
    // players signing up until the area is ready. Admins still reach it via the Admin Only sidebar
    // entry, and existing /running/* URLs keep working.
    featureEnableRunning:          ((<any>import.meta).env.VITE_FEATURE_ENABLE_RUNNING === 'yes'),
    featureEnableMmClubCourt:      ((<any>import.meta).env.VITE_FEATURE_ENABLE_MM_CLUB_COURT === 'yes'),

    adsenseEnabled: (((<any>import.meta).env.VITE_ADSENSE_ENABLED || 'yes') === 'yes'),
    adsenseClient:  ((<any>import.meta).env.VITE_ADSENSE_CLIENT || 'ca-pub-6471700087527589'),
    // Dedicated ad unit for the event registration pages (override via VITE_ADSENSE_REGISTRATION_SLOT).
    adsenseRegistrationSlot: ((<any>import.meta).env.VITE_ADSENSE_REGISTRATION_SLOT || '2659685440'),
    // Ad unit for the public club landing pages; falls back to the registration unit until a dedicated one is created.
    adsenseClubSlot: ((<any>import.meta).env.VITE_ADSENSE_CLUB_SLOT || (<any>import.meta).env.VITE_ADSENSE_REGISTRATION_SLOT || '2659685440'),
    // Responsive ad unit for the team-sport organizer dashboard (gutter rails + bottom banner).
    adsenseProfileSlot: ((<any>import.meta).env.VITE_ADSENSE_PROFILE_SLOT || '9419111436'),
    // Gutter rails shown on every public marketing/tool sub-page (injected via FooterSection).
    adsenseContentSlot: ((<any>import.meta).env.VITE_ADSENSE_CONTENT_SLOT || '7249077814'),
    // Rewarded ads ("watch a video, create free"): serve Google's always-filled test ad instead of
    // a live one. Needed to exercise the flow before H5 Games Ads is approved / has fill.
    adRewardTest: ((<any>import.meta).env.VITE_AD_REWARD_TEST === 'yes'),

    isTestMode: (typeof document !== 'undefined' && document.cookie?.indexOf('TestMode=yes') >= 0),
    ads:        {
        android: {
            appOpen:      (<any>import.meta).env.VITE_AD_ANDROID_APP_OPEN,
            interstitial: (<any>import.meta).env.VITE_AD_ANDROID_INTERSTITIAL,
            delaySeconds: (<any>import.meta).env.VITE_AD_ANDROID_DELAY_SECONDS,
        },
        ios:     {
            appOpen:      (<any>import.meta).env.VITE_AD_IOS_APP_OPEN,
            interstitial: (<any>import.meta).env.VITE_AD_IOS_INTERSTITIAL,
            delaySeconds: (<any>import.meta).env.VITE_AD_IOS_DELAY_SECONDS,
        },
        test:    {
            appOpen:      (<any>import.meta).env.VITE_AD_TEST_APP_OPEN,
            interstitial: (<any>import.meta).env.VITE_AD_TEST_INTERSTITIAL,
            delaySeconds: (<any>import.meta).env.VITE_AD_TEST_DELAY_SECONDS,
        },
    },
};
